<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.797 7.992a2.119 2.119 0 0 0-4.047.88C4.75 10.043 5.7 11 6.875 11h.858c-.595.51-1.256.924-1.84 1.008a.75.75 0 0 0 .213 1.485c1.11-.16 2.128-.92 2.803-1.53.121-.11.235-.218.341-.323.106.105.22.213.34.322.676.611 1.693 1.372 2.804 1.53a.75.75 0 0 0 .212-1.485c-.583-.083-1.244-.497-1.839-1.007h.858a2.128 2.128 0 0 0 2.125-2.128 2.119 2.119 0 0 0-4.047-.88l-.453.996-.453-.996ZM7.835 9.5h-.96a.628.628 0 0 1-.625-.628.619.619 0 0 1 1.182-.26l.403.888Zm3.79 0h-.96l.403-.887a.619.619 0 0 1 1.182.259.628.628 0 0 1-.625.628Z"
    fill="currentColor"
/>
<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17.5 6a2 2 0 0 0-2-2h-11a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V6Zm-2-.5H10v.75a.75.75 0 0 1-1.5 0V5.5h-4A.5.5 0 0 0 4 6v3.043a.75.75 0 0 1 0 1.414V14a.5.5 0 0 0 .5.5h4v-1a.75.75 0 0 1 1.5 0v1h5.5a.5.5 0 0 0 .5-.5v-3.5h-1.25a.75.75 0 0 1 0-1.5H16V6a.5.5 0 0 0-.5-.5Z"
    fill="currentColor"
/>
